import { getCalendarDaysUntil } from "@memorang/helpers/date";
import type { TFunction } from "i18next";

const getExamStatus = (
	examDateString: string | undefined,
	t: TFunction,
	showExamDate?: boolean,
) => {
	const daysLeft = getCalendarDaysUntil(examDateString);

	if (!daysLeft) {
		return "";
	}
	if (daysLeft < 0) {
		return t("dashboard.exam.daysAgo", { count: Math.abs(daysLeft) });
	}
	if (daysLeft > 0) {
		const status = t("dashboard.exam.untilExam", { count: daysLeft });
		return showExamDate ? `${examDateString} • ${status}` : status;
	}
	return t("dashboard.exam.isToday");
};

export { getExamStatus };
